/** Lowercase tokens that cannot be used as the public booking path slug (case-insensitive; full slug must not equal these). */
const RESERVED_SLUG_WORDS = new Set(
  [
    'admin',
    'assets',
    'callback',
    'claims',
    'logged-out',
    'refresh',
    'static',
    'status',
    'tokens',
    'manage',
    'settings',
    'staff',
    'store',
    'undefined',
    'null',
    'book',
    'booking',
    'bookings',
  ].map((w) => w.toLowerCase())
);

export function normalizeSlugInput(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '');
}

/** True when the normalized slug exactly matches a reserved word (e.g. `admin`, `logged-out`). */
export function isReservedSlug(slug: string): boolean {
  const s = normalizeSlugInput(slug);
  if (!s) return false;
  return RESERVED_SLUG_WORDS.has(s);
}
